import { CustomCellRendererProps } from 'ag-grid-react'

import {
  CONTRACT_TYPE_LABELS,
  ContractType,
} from '@/pages/instruments/new-instrument/constants/contract-types'

export interface ContractTypeCellRendererProps extends CustomCellRendererProps {
  value: ContractType
}

export const ContractTypeCellRenderer: React.FC<ContractTypeCellRendererProps> = ({ value }) => {
  const label = CONTRACT_TYPE_LABELS[value]

  return <>{label}</>
}
